import React from "react";
import './Simple_product.css'
import { useNavigate } from "react-router-dom";

const Simple_product = ({ product }) => {
  const navigate = useNavigate();
  return (

    <div class="container Simple_product" style={{ padding: '4px', boxSizing: 'border-box', width: 'auto' }}
    onClick={()=>{navigate(`/category/${product.category}`)}}>
      <div class="row">
        <div class="col-lg-12  col-md-12   col-12">
          <a href=""> <img src={product.src} class="img-fluid shadow" alt="Responsive image" style={{ padding: '0px', marginTop: '5px' }} /> </a>

        </div>

        <div style={{
          display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '10px', fontFamily: "Montserrat"
          , fontWeight: '600', fontSize: '.9rem', width : '100%'
        }}>{product.title}</div>
      </div>


    </div>

  );
};

export default Simple_product;